import React from "react";
import {
  RiFacebookCircleLine,
  RiInstagramLine,
  RiLinkedinBoxLine,
  RiTwitterLine,
  RiYoutubeLine,
} from "react-icons/ri";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useModalTicket } from "../../hooks/useModalTicket";
import Brand from "../../images/brand.svg";
import { FixedButton } from "../FixedButton";
import "./styles.scss";

interface FooterProps {}

function Footer({}: FooterProps) {
  const { width } = useBreakpoint();
  const { isModalOpen } = useModalTicket();

  return (
    <>
      <footer className="footer">
        <div>
          <div className="linksSection">
            <div className="column">
              <img src={Brand} alt="Logo Koin" className="brand" />

              <div className="socialMedias">
                <a
                  href="https://www.facebook.com/KoinBrasil"
                  target="_blank"
                  rel="noreferrer noopener"
                  id="facebookKoin"
                >
                  <RiFacebookCircleLine size={24} />
                </a>

                <a
                  href="https://www.instagram.com/koin.br"
                  target="_blank"
                  rel="noreferrer noopener"
                  id="instagramKoin"
                >
                  <RiInstagramLine size={24} />
                </a>

                <a
                  href="https://twitter.com/koin_br"
                  target="_blank"
                  rel="noreferrer noopener"
                  id="twitterKoin"
                >
                  <RiTwitterLine size={24} />
                </a>

                <a
                  href="https://br.linkedin.com/company/koinbr"
                  target="_blank"
                  rel="noreferrer noopener"
                  id="linkedInKoin"
                >
                  <RiLinkedinBoxLine size={24} />
                </a>

                <a
                  href="https://www.youtube.com/c/KOINBRASIL"
                  target="_blank"
                  rel="noreferrer noopener"
                  id="youTubeKoin"
                >
                  <RiYoutubeLine size={24} />
                </a>
              </div>
            </div>

            <div className="column">
              <h4>Sobre a Koin</h4>

              <a
                href="https://www.koin.com.br/sobre-nos"
                target="_blank"
                rel="noreferrer noopener"
              >
                Sobre nós
              </a>
              <a
                href="https://jobs.quickin.io/koin"
                target="_blank"
                rel="noreferrer noopener"
              >
                Vagas
              </a>
            </div>

            <div className="column">
              <h4>Contato</h4>

              <a
                href="https://www.koin.com.br/atendimento"
                target="_blank"
                rel="noreferrer noopener"
              >
                Central de ajuda
              </a>
              <a
                href="https://www.koin.com.br/koin-na-midia"
                target="_blank"
                rel="noreferrer noopener"
              >
                Koin na mídia
              </a>
            </div>

            <div className="column">
              <h4>Termos & Políticas</h4>

              <a
                href="https://parcele.koin.com.br/termos"
                target="_blank"
                rel="noreferrer noopener"
              >
                Termos e condições
              </a>

              <a
                href="https://www.koin.com.br/politica-de-privacidade"
                target="_blank"
                rel="noreferrer noopener"
              >
                Política de privacidade
              </a>

              <a
                href="https://www.koin.com.br/politica-de-cookies"
                target="_blank"
                rel="noreferrer noopener"
              >
                Política de cookies
              </a>
            </div>
          </div>

          <div className="aboutSection">
            <div>
              <p>Copyright © 2021 KOIN - Todos os direitos reservados.</p>

              <p>
                KOIN Adm. de Cartões e Meios de Pagamento S.A CNPJ
                17.991.841/0001-00 - Av. Paulista, 2421 - 13º Andar - Bela Vista
                - CEP: 01310-300.
              </p>

              <p>
                A utilização de qualquer serviço prestado por meio deste site
                implica na aceitação dos termos de uso e da Política de
                Privacidade KOIN.
              </p>
            </div>

            <div>
              <p>
                A KOIN é uma instituição de pagamento, obedece às premissas da
                Lei nº 12.865, de 9 de outubro de 2013, e aos regulamentos e
                circulares do Banco Central do Brasil. A KOIN não é uma
                instituição financeira mas atua como correspondente bancária da
                BMP Money Plus Sociedade de Crédito Direto S.A., CNPJ n.º
                34.337.707/0001-00 e da AYMORÉ CRÉDITO, FINANCIAMENTO E
                INVESTIMENTO S.A., CNPJ nº 07.707.650/000110, nos termos da
                Resolução nº. 3.954, de 24 de fevereiro de 2011, do Banco
                Central do Brasil.
              </p>
            </div>
          </div>
        </div>
      </footer>
      {width < 769 && !isModalOpen && <FixedButton />}
    </>
  );
}

export { Footer };
